import { render, staticRenderFns } from "./SenderSelector.vue?vue&type=template&id=68a967a0&scoped=true&"
import script from "./SenderSelector.vue?vue&type=script&lang=ts&"
export * from "./SenderSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SenderSelector.vue?vue&type=style&index=0&id=68a967a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a967a0",
  null
  
)

export default component.exports